












import VueOptions from '@utils/VueOptions'

settings =
  name: 'FormFieldText'

  vue:
    props: ['value', 'errors', 'placeholder', 'disabled', 'replace']

    data: ->
      value_: @value

    methods:
      hiInputChange: (value) ->
        unless @isEmptyValue(@replace)
          for search, replaceValue of @replace
            regex = new RegExp search, 'g'
            value = value.replaceAll regex, replaceValue
          @value_ = value
        @$emit 'input', value

    watch:
      value: (v) ->
        @value_ = v

export default VueOptions.vue settings
